<template>
    <div id="footer" class="footer">
        <!-- span style="font-weight: bold">Project: </span>
            {{ GET_job?.info.obs ?? '' }} / 
        <span style="font-weight: bold">Pasta: </span>
            {{ instanceName }} -->

        <!-- <span style="font-size:20px; font-weight:bolder;">
            {{ GET_activeStepCaption }}
        </span> -->
        <section class="footer-label">
            <!-- Label preview -->
            <template v-if="previewNode.label && !activeNode.label">
                <section class="footer-label-header">
                    <div v-if="previewLabel?.color" class="footer-label-color" :style="{
                        background: previewLabel?.color,
                    }">
                    </div>
                    <span class="footer-label-title">
                        {{ previewLabel?.caption || previewLabel?.label }}
                    </span>
                </section>
            </template>

            <!-- Label ativo -->
            <template v-if="activeNode.label">
                <section class="footer-label-header">
                    <div v-if="footerLabel?.color" class="footer-label-color" :style="{
                        background: footerLabel.color,
                    }">
                    </div>
                    <span class="footer-label-title">
                        {{ footerLabel?.caption || footerLabel?.label }}
                    </span>
                </section>
                <labelNodeReportTextCMP v-if="footerLabel.label && GET_activeLabelReportNode"
                    v-show="showLabelReportText" :reportNode="GET_activeLabelReportNode" :maxWidth="400"
                    :canEdit="GET_execMode == gConsts.rt.execModes.WORK" :reportText="labelReportText"
                    @onUpdateInputText="updateLabelReportText">
                </labelNodeReportTextCMP>
            </template>
        </section>
        <template v-if="displaySearchHelp">
            <span class="footer-help footer-help--search">
                Começe a digitar ou pressione
                <Kbd text="Ctrl + F" />
                para pesquisar um termo
            </span>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import labelNodeReportTextCMP from '@/components/panels/relatorioDinamico/nodes/labelNode/labelNodeReportText.vue';
import Kbd from '@/components/ui/text/kbd.vue';

import { gConsts } from '@/globals/gConsts';
import { evtBus } from '@/main';
import { reportUtils } from '@/features/report/lib/reportUtils';
export default {
    name: 'footerCMP',
    components: {
        labelNodeReportTextCMP,
        Kbd
    },

    data() {
        return {
            gConsts: gConsts,
            activeNode: {
                label: null,
                layer: null,
                step: null
            },
            previewNode: {
                label: null,
            },
            state: {
                openedSidebarPanel: null,
                focusLocation: null,
            },
        }
    },

    computed: {
        ...mapGetters([
            'GET_nodesArray',
            'GET_colorTheme',
            'GET_activeLabelReportNode',
            'GET_activeStepCaption',
            'GET_execMode',
        ]),

        displaySearchHelp() {
            if (this.activeNode.label)
                return false;
            return true;
        },

        previewLabel() {
            if (!this.previewNode.label)
                return null;

            const color = gConsts.ui.prettyColors[this.previewNode.label.layout.color?.toLowerCase()] || this.previewNode.label.layout.color;
            return {
                color: color,
                caption: this.previewNode.label.layout.caption,
                label: this.previewNode.label.layout.label,
            }
        },

        footerLabel() {
            if (!this.activeNode.label) {
                return null;
                // if (this.GET_execMode == gConsts.rt.execModes.VIEW) {
                //     return {
                //         color: null,
                //         caption: '',
                //         label: '',
                //     }
                // }
                // return {
                //     color: null,
                //     caption: this.activeNode.layer?.layout.caption || this.activeNode.step?.layout.caption || '',
                //     label: '',
                // }
            }

            var caption = this.activeNode.label.layout.caption;
            var label = this.activeNode.label.layout.label;

            if (this.activeNode.label.layout.parent == gConsts.layer.locations.TEETH_SEG) {
                caption = "Dente " + caption;
                label = '';
            }

            const color = gConsts.ui.prettyColors[this.activeNode.label.layout.color?.toLowerCase()] || this.activeNode.label.layout.color;

            return {
                color: color,
                caption: caption,
                label: label,
            }
        },

        labelReportText() {
            if (!this.activeNode.label)
                return '';
            return this.GET_activeLabelReportNode?.reportText || reportUtils.getInitialReportText(this.activeNode.label);
        },

        showLabelReportText() {
            return this.activeNode.layer && this.labelReportText?.length > 0;
        }
    },

    methods: {

        updateLabelReportText(reportText) {
            if (!this.activeNode.label)
                return;

            this.$store.dispatch('ACT_reportNodes_updateLabelReportText', {
                labelId: this.activeNode.label.id,
                text: reportText
            });
        }
    },

    created() {
        evtBus.$on('evt_activateNode', (payload) => {
            this.activeNode.label = this.GET_nodesArray.find(node => node.id == payload.label);
            this.activeNode.layer = this.GET_nodesArray.find(node => node.id == payload.layer);
            this.activeNode.step = this.GET_nodesArray.find(node => node.id == payload.step);
        });

        evtBus.$on('evt_tool_displayLabel', (payload) => {
            this.previewNode.label = this.GET_nodesArray.find(node => node.id == payload.label);
        });

        evtBus.$on('evt_medidor_focusLocationChanged', (payload) => {
            this.state.focusLocation = payload.focusLocation;
        });

        evtBus.$on('evt_sidebarPanel_onExpanded', (panelId) => {
            this.state.openedSidebarPanel = panelId;
        });

        evtBus.$on('evt_sidebarPanel_onCollapse', () => {
            this.state.openedSidebarPanel = null;
        });
    },

}
</script>

<style scoped>
.footer {
    padding: 5px 0;
    background: var(--background-white);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-top: 1px solid var(--border-primary);
    z-index: 110;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    min-height: 30px;
}

.footer-label {
    display: flex;
    flex-direction: column;
    padding: 2.5px 0;
}

.footer-label-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-sm);
}

.footer-label-color {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: var(--radius-sm);
}

.footer-label-title {
    font-family: var(--font-family-primary);
    color: var(--color-black);
    font-size: var(--text-md);
    font-weight: 600;
    line-height: var(--leading-loose);
}

.footer-help {
    font-family: var(--font-family-primary);
    color: var(--color-dark-gray);
    font-size: var(--text-xs);
    font-weight: 500;
    line-height: 1;
    text-align: center;
}

.footer-help--search {
    position: absolute;
    right: var(--spacing-md);
    bottom: 50%;
    transform: translateY(50%);
}

.footer-label :deep(.label-line-input),
.footer-label :deep(.report-line-text) {
    font-size: calc(var(--text-sm) * 1.1);
}

@media (max-width: 1024px) {
    .footer-help--search {
        max-width: 200px;
    }
}
</style>